import { Flex, ScrollArea, Separator } from "@radix-ui/themes";
import { TrackerItem } from "@/v2/entities/tracker/Tracker.model";
import TrackerItemView from "@/routes/quality/ticket-qa-score/TrackerItemView";
import { InteractionViewTabContentEmptyState } from "../parts/InteractionViewTabContentEmptyStateProps";
import { TrackerIcon } from "../assets/TracketIcon";

interface TrackerProps {
  data: TrackerItem[];
  refetch: () => void;
}

export function Tracker({ data, refetch }: TrackerProps) {
  if (data.length === 0) {
    return (
      <InteractionViewTabContentEmptyState
        icon={<TrackerIcon />}
        title="Not captured by any tracker"
        description="This interaction didn’t match the conditions of an active tracker."
      />
    );
  }

  return (
    <Flex height={"100%"} direction={"column"} overflow={"hidden"} gap={"4"}>
      <ScrollArea scrollbars="vertical">
        <Flex
          py={"4"}
          px={"6"}
          height={"100%"}
          direction={"column"}
          overflow={"hidden"}
          gap={"4"}
        >
          {data.map((item) => {
            if (!item.tracker) {
              return <></>;
            }

            return (
              <TrackerItemView
                key={item.id}
                trackerItem={item}
                tracker={item.tracker}
                refetch={refetch}
              />
            );
          })}
        </Flex>
      </ScrollArea>
    </Flex>
  );
}
